import { useEffect } from 'react';

export async function LoginUsuario({
  input_username,
  input_password,
  servidor,
  rememberMe,        // <-- lo añadimos aquí
  navigate
}) {
  if (!servidor) {
    console.error("SERVER_URL es null. No se puede hacer la petición.");
    return false;
  }

  try {
    const response = await fetch(`${servidor}/login`, {
      method: 'POST',
      credentials: 'include',    // para cookies HttpOnly
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: input_username,
        password: input_password,
        remember: rememberMe            // <-- lo mandamos al servidor
      }),
      keepalive: false,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.mensaje || "Error al iniciar sesión");
    }

    // Guarda solo datos no sensibles en localStorage
    localStorage.setItem('username', data.username);
    localStorage.setItem('cargo', data.cargo);

    console.log('%c CONEXIÓN EXITOSA','color:green; font-size:5vh');
    navigate('/home');
    window.location.reload();
    // window.location.href('/home')
    return true;

  } catch (error) {
    console.error("Hubo un error al iniciar sesión:", error);
    return false;
  }
}


export async function silentRefresh(servidor) {
  if (!servidor) return false;

  try {
    const res = await fetch(`${servidor}/refresh`, {
      method: 'POST',
      credentials: 'include'
    });

    return res.ok;
  } catch {
    return false;
  }
}


export async function LogoutUsuario(servidor) {  
  try {
    // Obtén la URL de tu servidor igual que en las demás funciones
    // const SERVER_URL = await _SERVER_URL();

    // Llama al endpoint /logout para que el servidor expire las cookies
    const response = await fetch(`${servidor}/logout`, {
      method: 'POST',               // o GET, según tu diseño
      credentials: 'include',       // envía las cookies (incluidas HttpOnly)
      headers: {
        'Content-Type': 'application/json',
      }
    });

    if (!response.ok) {
      const err = await response.json();
      throw new Error(err.mensaje || 'Error al cerrar sesión');
    }

    // Opcionalmente, si tu logout devolviera JSON:
    // const data = await response.json();

    // Redirige al login o página pública
    window.location.href = '/login';
  } catch (error) {
    console.error('Error cerrando sesión:', error);
  }
}

/**
 * Solicita al servidor el envío del enlace para restablecer contraseña.
 * @param {Object} params
 * @param {string} params.username — Nombre de usuario cuyo correo recibirá el link.
 * @returns {Promise<boolean>} — Resuelve true si se envió correctamente, false de lo contrario.
 */
export async function ResetNewPassword({ password, token }) {

  console.log('password', {'password': password} )

  try {
    // const res = await fetch('/reset_password', {
     const res = await fetch(`/ResetPassword/${token}`,{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 'password': password })
    });

    if (!res.ok) {
      // Puedes leer el mensaje de error del servidor si lo necesitas:
      // const err = await res.json();
      return false;
    }

    const data = await res.json();

    console.log('data',data)

    // data.Message debería ser 'Enlace enviado para restablecer la contraseña.'
    return data;

  } catch (e) {
    console.error('ResetNewPassword error:', e);
    return false;
  }
}

/**
 * Hace un POST a /get_link para obtener un link desde el servidor.
 * @param {Object} payload — Datos que quieras enviar en el body.
 * @returns {Promise<Object>} — Respuesta JSON del servidor.
 * @throws {Error} — Si el servidor responde con error o hay problema de red.
 */
export async function getLink(nombre, correo, servidor) {

  console.log('data',{ 
        'username':nombre,
        'correo':correo
       })
  if (!servidor) {
    console.error("SERVER_URL es null. No se puede hacer la petición.");
    return false;
  }

  try {

    console.log('URL',`${servidor}/get_link`)
    const response = await fetch(`${servidor}/get_link`, {
      method: 'POST',
      credentials: 'include',    // para cookies HttpOnly
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: nombre,
        correo: correo,
      }),
      keepalive: false,
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.mensaje || "Error al enviar correo");
    }
    console.log('%c Correo enviado','color:green; font-size:5vh');
    return true;
  } catch (error) {
    console.error("Hubo un error al iniciar sesión:", error);
    return false;
  }
}


// ? METODO DE refreshToken

// export function useAutoRefresh(servidor, onSessionExpired) {
//   useEffect(() => {
//     if (!servidor) return;

//     // función interna que refresca y dispara expiración si falla
//     const doRefresh = async () => {
//       const ok = await refreshToken(servidor);
//       if (!ok && typeof onSessionExpired === "function") {
//         onSessionExpired();
//       }
//     };

//     // primer refresco tras 1 minuto
//     const timeoutId = setTimeout(() => {
//       doRefresh();
//       // una vez hecho el primer refresh, arranca el intervalo
//       const intervalId = setInterval(doRefresh, 15 * 60 * 1000);
//       // guarda intervalId para limpieza
//       // lo colocamos en el cierre del effect usando una variable accesible
//       (cleanup).intervalId = intervalId;
//     }, 60 * 1000);

//     // función de limpieza: borra timeout y posible intervalo
//     function cleanup() {
//       clearTimeout(timeoutId);
//       if ((cleanup).intervalId) {
//         clearInterval((cleanup).intervalId);
//       }
//     }

//     return cleanup;
//   }, [servidor, onSessionExpired]);
// }

export function useAutoRefresh(servidor, onSessionExpired, enabled = true) {
  useEffect(() => {
    if (!servidor || !enabled) return;

    // función interna que refresca y dispara expiración si falla
    const doRefresh = async () => {
      const ok = await refreshToken(servidor);
      if (!ok && typeof onSessionExpired === "function") {
        onSessionExpired();
      }
    };

    // primer refresco tras 1 minuto
    const timeoutId = setTimeout(() => {
      doRefresh();
      // una vez hecho el primer refresh, arranca el intervalo
      const intervalId = setInterval(doRefresh, 15 * 60 * 1000);
      // guarda intervalId para limpieza
      // lo colocamos en el cierre del effect usando una variable accesible
      (cleanup ).intervalId = intervalId;
    }, 30 * 1000);

    // función de limpieza: borra timeout y posible intervalo
    function cleanup() {
      clearTimeout(timeoutId);
      if ((cleanup ).intervalId) {
        clearInterval((cleanup).intervalId);
      }
    }

    return cleanup;
  }, [servidor, onSessionExpired, enabled]);
}

export async function refreshToken(servidor) {
  try {
    const res = await fetch(`${servidor}/refresh`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" }
    });

    if (!res.ok) {
      throw new Error("Error al refrescar token");
    }

    return true;
  } catch (e) {
    console.error("Falló refreshToken:", e);
    return false;
  }
}
// export function useAutoRefresh(servidor) {
//   useEffect(() => {
//     if (!servidor) return;
//     // refresco inicial
//     refreshToken(servidor);

//     // cada 15′
//     const id = setInterval(() => refreshToken(servidor), 15 * 60 * 1000);
//     return () => clearInterval(id);
//   }, [servidor]); // ¡incluye servidor en deps!
// }

// export async function refreshToken(servidor) {
//   try {
//     const res = await fetch(`${servidor}/refresh`, {
//       method: 'POST',
//       credentials: 'include',
//       headers: { 'Content-Type': 'application/json' },
//       keepalive: false,
//     });
//     if (!res.ok) {
//       const err = await res.json();
//       throw new Error(err.mensaje || 'Error al refrescar token');
//     }
//     return true;
//   } catch (e) {
//     console.error('Falló refreshToken:', e);
//     return false;
//   }
// }
